<template></template>

<script>
import { fromShortCodesToCurrency, currencyAppearance } from '@/components/shared/currencyExchange';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      isSpecialDealProduct: false,
      currency: 'USD',
      exchangeValue: -1,
      okBtnText: '',
      isLoading: true,
      product: undefined,
      hasDiscount: false,
      needTwoDecimals: false,
      needConverter: false,
      currentProducts: undefined,
    };
  },
  async created() {
    this.isLoading = true;
    this.okBtnText = this.okText;
    await this.productList({}).then((productListResponse) => {
      //  this.product = productListResponse.products[0];
      this.currentProducts = productListResponse.products;
      this.product = productListResponse.products.find(
        product => product.bestDeal === true || product.specialDeal === true,
      );
      let specialDealIndex = -1;
      specialDealIndex = productListResponse.products.find(
        product => product.specialDeal === true,
      );
      this.isSpecialDealProduct =
        specialDealIndex != -1 && specialDealIndex != undefined;
      this.hasDiscount = this.product.discountPercentage != undefined && this.product.discountPercentage > 0;
      // this.isSpecialDealProduct = true;
    });
    this.currency = fromShortCodesToCurrency[this.user.languageCode] ?? fromShortCodesToCurrency.default;
    await this.getExchangeRate(this.currency).then((response) => {
      this.exchangeValue = response.response.rate;
    });
    if (['ar_AR', 'en_US', 'vi_VN', 'pt_PT', 'pt', 'ar', 'en'].includes(this.user.languageCode)) {
      this.needConverter = false;
    } else {
      this.needConverter = true;
    }
    this.needTwoDecimals = currencyAppearance[this.currency];
    this.isLoading = false;
  },
  methods: {
    ...mapActions({
      productList: 'subscriptions/productList',
      getExchangeRate: 'subscriptions/getExchangeRate',
    }),
  },
  computed: {
    ...mapGetters({
      getLang: 'settings/userSelectedLanguage',
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    getDiscountPercentageText() {
      return this.$t('app.salesLargeModal.discountLabelText', {
        percent: this.product.discountPercentage,
      });
    },
    getCountryPriceValue() {
      if (this.needTwoDecimals) {
        return (this.product.price * this.exchangeValue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
      return Math.round(this.product.price * this.exchangeValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    getCountryPrice() {
      if (this.exchangeValue != -1) {
        if (this.needConverter) {
          return this.$t('app.product.convertedPrice', { price: this.getCountryPriceValue, currency: this.currency });
        }
        return this.$t('app.product.price', { price: this.getCountryPriceValue, currency: this.currency });
      }
      return '';
    },
    getCountryMonthlyPriceValue() {
        if (this.needTwoDecimals) {
          return (this.product.monthlyPrice() * this.exchangeValue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        return Math.round(this.product.monthlyPrice() * this.exchangeValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    getCountryMonthlyPrice() {
      if (this.exchangeValue != -1) {
        if (this.needConverter) {
          return this.$t('app.product.convertedPrice', { price: this.getCountryMonthlyPriceValue, currency: this.currency });
        }
        return this.$t('app.product.price', { price: this.getCountryMonthlyPriceValue, currency: this.currency });
      }
      return '';
    },
    usedTrial() {
      return this.user.state.promotion.usedTrial;
    },
    getButtonLabel() {
      if (this.product == undefined || this.isLoading) {
        return this.usedTrial
          ? this.$t('app.testResult.fullAutoSales.withoutTrialproductInfo', { countryPrice: '....', price: '....', period: '....' })
          : this.$t('app.general.continueButtonLabel', {
              countryPrice: '....',
              price: '....',
              period: '....',
            });
      }
        if (this.usedTrial) {
              return this.$t('app.testResult.fullAutoSales.withoutTrialproductInfo', { countryPrice: this.getCountryPrice,
price: this.product.displayDiscountPrice(),
              period: this.product.renewMonthPeriod == 12 ? this.$t('app.product.periodOfTime.year') :
              this.product.renewMonthPeriod == 1200 ? this.$t('app.product.periodOfTime.lifetime') :
              this.product.renewMonthPeriod == 1 ? this.$t('app.product.periodOfTime.month') :
              this.$t('app.product.periodOfTime.monthsWithPeriodValue', { period: this.product.renewMonthPeriod }) });
        }
          return this.$t('app.general.continueButtonLabel', {
            countryPrice: this.getCountryPrice,
            price: this.product.displayDiscountPrice(),
            period:
              this.product.renewMonthPeriod == 12
                ? this.$t('app.product.periodOfTime.year')
                : this.product.renewMonthPeriod == 1200
                ? this.$t('app.product.periodOfTime.lifetime')
                : this.product.renewMonthPeriod == 1
                ? this.$t('app.product.periodOfTime.month')
                : this.$t('app.product.periodOfTime.monthsWithPeriodValue', {
                    period: this.product.renewMonthPeriod,
                  }),
          });
    },
    getOkButtonText() {
      if (this.isReSubscription) {
        if (this.isLoading || this.product == undefined) {
          return this.$t('app.resub.buttonWithProduct', {
            displayPrice: '....',
            countryPrice: '....',
          });
        }
        return this.$t('app.resub.buttonWithProduct', {
          displayPrice: this.product.displayMonthlyPrice(),
          countryPrice: this.getCountryMonthlyPrice,
        });
      }
        if (this.usedTrial) {
          if (this.isLoading || this.product == undefined) {
            return this.$t('app.proPromotionBand.buttonWithProduct', {
              price: '....',
              countryPrice: '....',
            });
          }
          return this.$t('app.proPromotionBand.buttonWithProduct', {
            price: this.product.displayMonthlyPrice(),
            countryPrice: this.getCountryMonthlyPrice,
          });
        }
          if (this.isExtraOffer) {
            return this.$t('app.islandNotification.islandExtraOfferOkTitle');
          }
          return this.$t('app.proPopup.beforeTrialCtaButtonText');
    },
    getAutoManualSaleButtonLabel() {
      if (this.product == undefined || this.isLoading) {
        return this.usedTrial
          ? this.$t('app.testResult.fullAutoSales.withoutTrialproductInfo', { countryPrice: '....', price: '....', period: '....' })
          : this.$t('app.general.continueButtonLabel', {
              countryPrice: '....',
              price: '....',
              period: '....',
            });
      }
        if (this.usedTrial) {
              return this.$t('app.testResult.fullAutoSales.withoutTrialproductInfo', { countryPrice: this.getCountryPrice,
price: this.product.displayDiscountPrice(),
              period: this.product.renewMonthPeriod == 12 ? this.$t('app.product.periodOfTime.year') :
              this.product.renewMonthPeriod == 1200 ? this.$t('app.product.periodOfTime.lifetime') :
              this.product.renewMonthPeriod == 1 ? this.$t('app.product.periodOfTime.month') :
              this.$t('app.product.periodOfTime.monthsWithPeriodValue', { period: this.product.renewMonthPeriod }) });
        }
          return this.$t('app.general.continueButtonLabel', {
            countryPrice: this.getCountryPrice,
            price: this.product.displayDiscountPrice(),
            period:
              this.product.renewMonthPeriod == 12
                ? this.$t('app.product.periodOfTime.year')
                : this.product.renewMonthPeriod == 1200
                ? this.$t('app.product.periodOfTime.lifetime')
                : this.product.renewMonthPeriod == 1
                ? this.$t('app.product.periodOfTime.month')
                : this.$t('app.product.periodOfTime.monthsWithPeriodValue', {
                    period: this.product.renewMonthPeriod,
                  }),
          });
    },
    getAutoManualSaleButtonText() {
      if (this.usedTrial) {
        if (this.isLoading || this.product == undefined) {
          return this.$t('app.proPromotionBand.buttonWithProduct', {
            price: '....',
            countryPrice: '....',
          });
        }
        return this.$t('app.proPromotionBand.buttonWithProduct', {
          price: this.product.displayMonthlyPrice(),
          countryPrice: this.getCountryMonthlyPrice,
        });
      }
        if (this.isLoading || this.product == undefined) {
          return this.$t('app.salesFlow.buttonWithProduct', {
            countryPrice: '....',
            period: '....',
          });
        }
        return this.$t('app.salesFlow.buttonWithProduct', {
          countryPrice: this.getCountryMonthlyPrice,
          period: this.getAutoOrManualSaleTimePeriod,
        });
    },
    getAutoOrManualSaleTimePeriod() {
      if (this.product != undefined) {
        return this.product.renewMonthPeriod == 12
          ? this.$t('app.product.periodOfTime.yearWithPeriodValue', {
              period: 1,
            })
          : this.product.renewMonthPeriod == 1200
          ? this.$t('app.product.periodOfTime.lifetime')
          : this.product.renewMonthPeriod == 1
          ? this.$t('app.product.periodOfTime.monthWithPeriodValue', {
              period: 1,
            })
          : this.$t('app.product.periodOfTime.monthsWithPeriodValue', {
              period: this.product.renewMonthPeriod,
            });
      }
      return '';
    },
    isReSubscription() {
      return this.titleText == undefined
        ? false
        : this.titleText == 'app.sales.popups.resubSales.title';
    },
    isExtraOffer() {
      return this.type == undefined ? false : this.type == 'islandExtraOffer';
    },
    getDescriptionText() {
      if (
        this.descriptionText === 'app.sales.popups.resubSales.subtitle' &&
        this.user
      ) {
        if (this.isLoading || this.product == undefined) {
          return this.$t(this.descriptionText, {
            price: '....',
            period: '....',
            countryPrice: '....',
          });
        }
          return this.$t(this.descriptionText, {
            price: this.product.displayMonthlyPrice(),
            countryPrice: this.getCountryMonthlyPrice,
            period:
              this.product.renewMonthPeriod == 12
                ? this.$t('app.product.periodOfTime.toYearWithPeriodValue', {
                    period: 1,
                  })
                : this.product.renewMonthPeriod == 1200
                ? this.$t('app.product.periodOfTime.lifetime')
                : this.product.renewMonthPeriod == 1
                ? this.$t('app.product.periodOfTime.toMonthWithPeriodValue', {
                    period: 1,
                  })
                : this.$t('app.product.periodOfTime.toMonthsWithPeriodValue', {
                    period: this.product.renewMonthPeriod,
                  }),
          });
      }
        return this.$t(this.descriptionText);
    },
    isOkButtonTextHtml() {
      if (
        (this.okText === 'app.proPromotionBand.buttonWithProduct' &&
          this.user) ||
        this.isReSubscription ||
        this.usedTrial
      ) {
        return true;
      }
      return false;
    },
    user() {
      return this.loggedInUserProfile.user;
    },
    getSelfAdButtonText() {
      if (this.usedTrial) {
        if (this.isLoading || this.product == undefined) {
          return this.$t('app.proPromotionBand.buttonWithProduct', {
            price: '....',
            countryPrice: '....',
          });
        }
          return this.$t('app.proPromotionBand.buttonWithProduct', {
            price: this.product.displayMonthlyPrice(),
            countryPrice: this.getCountryMonthlyPrice,
          });
      }
        return this.$t('app.selfAd.noAdsButtonText');
    },
  },
};
</script>
